"use strict";

/**
* Объект шапки проводника.
*
* @class WebAccess.components.Header
* @extends BaseObject
* @property {string} _containerID - ID элемента DOM, в котором рендерится react-компонента шапки
* @property {object} _model - Модель шапки проводника
*/

(function (global) {
  var Header = BaseObject.extend({

    _containerId: "",
    _model: {},
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Конструктор
     * @param {string} containerId - ID элемента DOM, в котором рендерится react-компонента шапки
     * @param {object} model - Модель шапки проводника
     * @param {array} childObjects - Массив объектов в шапке проводника, которыми можно манипулировать через КОМ
     * @method WebAccess.components.Header#init
     */
    init: function (containerId, model, childObjects) {
      var me = this;
      me._containerId = containerId;
      me._model = model;
      childObjects.forEach(function(object) {
        object.bind(object['class'].EVENT.CHANGE_STATE, function () {
          me._render();
        });
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отрендерить компоненту ExplorerHeader с помощью react.
     */
    _render: function () {
      var me = this;
      ReactDOM.render(
        React.createElement(ExplorerHeader, me._model),
        document.getElementById(me._containerId)
      );
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.Header = Header;

})(window.WebAccess.components);
